import { ILeaderboardDetails, TComp } from "../../@types";
import { CompetitionViewModel } from "../../ViewModel";
import { PlayViewModel } from "../../Views/Play/ViewModel";
import Leaderboard from "../Leaderboard";

export const LeaderboardWidget = () => {
  const { data } = CompetitionViewModel({
    activeOnly: true,
  });

  const competitions = data?.competitions as TComp[];

  if (!competitions) return <></>;

  const present = competitions?.filter(
    (competition) => parseInt(competition?.campaignEnd) > Date.now(),
  );
  const currentCompetition = present[0];

  if (!currentCompetition) return <></>;
  return <LeaderboardRenderer competition={currentCompetition} />;
};

const LeaderboardRenderer = ({ competition }: { competition: TComp }) => {
  const { campaign } = PlayViewModel(competition.slug);

  if (!campaign?.leaderboardDetails) return <></>;

  return (
    <Leaderboard
      leaderboardDetails={campaign?.leaderboardDetails}
      size="small"
      showButton={true}
      showCampaignImage={true}
    />
  );
};
